import { useTranslation } from "react-i18next";

/**
 * Centralized toast message keys and helpers
 * Ensures consistent i18n usage across the application
 */
export const useToastMessages = () => {
  const { t } = useTranslation();

  return {
    // Common messages
    saving: () => t("saving") || "Speichere...",
    error: () => t("error") || "Fehler aufgetreten",
    success: () => t("success") || "Erfolgreich",

    // Listing-related messages
    listingCreated: () => t("listing.created") || "Anzeige erstellt.",
    listingUpdated: () => t("listing.updated") || "Anzeige aktualisiert.",
    listingDeleted: () => t("listing.deleted") || "Anzeige gelöscht.",
    listingError: () => t("listing.error") || "Speichern fehlgeschlagen.",
    listingDeleteError: () =>
      t("listing.deleteError") || "Löschen fehlgeschlagen.",
  };
};
